import {createDataStore} from './createDataStore';

// Caches /data/scipyData.json for the SciPy tutorial pages.
// See createDataStore for the fetch-once / persist-to-localStorage behaviour.
// Bump the version below whenever scipyData.json's content changes, to
// invalidate copies already cached in returning visitors' browsers.
export const useScipyDataStore = createDataStore(
    '/data/scipyData.json',
    'scipy-data-store',
    ['slugs', 'nextPage', 'relatedPages', 'suggestedCourses'],
    1
);
